export default {"src":"/_next/static/media/algo.3a2b65a7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};